'use client';

import { Box, BoxProps } from '@coolblue-development/freddy';
import styled from '@emotion/styled';

import { StyledComparisonColumn } from '../ComparisonColumn';

const StyledPropertyColumn = styled(StyledComparisonColumn)`
  width: var(--comparison-column-width);

  &:first-of-type,
  &:first-of-type a {
    padding-left: 0;
  }

  &:first-of-type {
    display: none;
  }

  ${({ theme }) => theme.breakpoint.minWidth('md')} {
    &:first-of-type {
      padding-right: ${({ theme }) => theme.spacing[300]};
      word-break: break-word;
    }
  }

  ${({ theme }) => theme.breakpoint.minWidth('lg')} {
    &:first-of-type {
      display: flex;
      position: sticky;
      left: 0;
      background-color: ${({ theme }) => theme.color.background.base};
    }
  }

  ${({ theme }) => theme.breakpoint.maxWidth('md')} {
    &:first-of-type:not(:last-of-type) {
      display: none;
    }
  }
`;

const MobileStickyHeader = styled(Box)<BoxProps>`
  margin-top: ${({ theme }) => theme.spacing[300]};
  display: table;
  position: sticky;
  left: 0;
`;

const StyledPropertyRow = styled.div`
  border-bottom: ${({ theme }) =>
    theme.borderWidth[25] + ' solid ' + theme.color.border.interactiveBase};

  &:has(.property-row:not(.all-values-are-same):last-of-type) {
    border-bottom: none;
  }

  &.has-explanation {
    cursor: pointer;

    ${({ theme }) => theme.breakpoint.maxWidth('md')} {
      strong {
        color: ${({ theme }) => theme.color.font.additional};
        border-bottom: ${({ theme }) =>
          theme.borderWidth[25] + ' dashed ' + theme.color.font.additional};
      }
    }
  }
`;

const StyledPropertyIconButtonContainer = styled.div`
  width: 2.4rem;

  ${({ theme }) => theme.breakpoint.minWidth('md') + ' && ' + theme.breakpoint.maxWidth('lg')} {
    padding-left: 0;
  }
`;

export {
  MobileStickyHeader,
  StyledPropertyColumn,
  StyledPropertyIconButtonContainer,
  StyledPropertyRow
};
